<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/services">Services</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Managed Services
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Managed Services</h2>
              <p class="lead">
                IT leaders are faced with a challenging balancing act: deploying new technologies for growth, profitability, and new services, while operating complex multi-technology and multi-vendor environments to realize efficiencies and savings. As more IT organizations look outside their walls for solutions, external IT services are growing significantly faster than internal IT spend . CIOs are leveraging Managed Services providers for access to the latest technologies, innovative approaches, risk reduction, specialized skills, faster integration, efficient knowledge transfer, and operating budget flexibility.

              </p>
              <p class="lead">
             Our managed services address daily IT management needs, enabling your internal IT staff to better focus on strategic initiatives. We provide rich infrastructure monitoring, robust solution management, and comprehensive lifecycle services, helping you deliver specific business outcomes. Our managed service offerings help you overcome the critical challenges associated with people, process and technology while providing your business with flexibility, elasticity and reliability.
              </p>

              <p class="lead">
                  Our Managed Services include:
              </p>
    <ul class="lead">
              <li><router-link to=""> Collaboration </router-link></li>
               <li><router-link to=""> Managed data centters </router-link></li>
                <li><router-link to=""> Manage networking </router-link></li>
                 <li><router-link to=""> Locations serviced </router-link></li>
                  <li><router-link to=""> Service management </router-link></li>
            
      
    </ul>

             
            </div>

            <div class="col-lg-4">
              <ServicesSideNav></ServicesSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import ServicesSideNav from "./ServicesSideNav";
export default {
  name: "cloud overview",
  components: {
    ServicesSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
